import Service from "./Service";

const baseUrl = "/api/pabellon";

export default {
    index(){
        return Service.get(`${baseUrl}`);
    }
}
